import lodash from 'lodash';
import {toJS} from 'mobx';

/**
 * The default blank drop shadow object.
 * @type {{blur: number, color: string, x: number, y: number}}
 */
export const DEFAULT_DROP_SHADOW = {
  blur: 0,
  color: '#000',
  x: 0,
  y: 0,
};

/**
 * The feedImage component.
 *
 * @param {string} url
 * @param {{}} feedImageData
 * @param {number} feedImageData.opacity
 * @param {{}=} feedImageData.dropShadow
 * @returns {{feedimage: {url: string}}}
 */
export function feedImageComponent(url, feedImageData = {}) {
  let safeUrl = (!url || url === 'null') ? null : String(url);

  const opacity = (feedImageData.opacity === undefined) ? 1 : feedImageData.opacity;
  const dropShadow = lodash.defaults(
    lodash.pick(feedImageData.dropShadow, lodash.keys(DEFAULT_DROP_SHADOW)),
    DEFAULT_DROP_SHADOW
  );

  return {
    feedimage: {
      type: feedImageData.type,
      url: safeUrl,
      dropShadow,
      opacity,
      default: {
        dropShadow,
        opacity,
      },
    },
  };
}

/**
 * Gets the feedImage component from the source item.
 *
 * @param {{feedimage: {url: string}}} item
 * @param {{}=} variables
 * @returns {{feedimage: {url: string}}}
 */
export function getFeedImageFromSource(item, variables) {
  if (!item.feedimage) {
    return {};
  }

  const feedimage = item.feedimage;

  let url = feedimage.url;

  const canEdit = lodash.get(item, 'compose.canEdit');
  const variableName = lodash.get(item, 'compose.variableName');
  if (canEdit && variableName) {
    const variableValue = lodash.get(variables, `feedimage.${variableName}`, '');

    if (variableValue && lodash.isString(variableValue)) {
      // The old deprecated variable style is a string with | delimiters.
      [url] = lodash.split(variableValue, '|', 2);
    } else if (variableValue) {
      // The ()s fix an eslint parsing error.
      ({url} = variableValue);
    }
  }

  return feedImageComponent(
    url,
    {
      type: feedimage.type,
      dropShadow: feedimage.dropShadow || undefined,
      opacity: feedimage.opacity,
    }
  );
}

/**
 * Parses an entity back into source JSON.
 *
 * @param {{}} entity
 * @returns {{}}
 */
export function getFeedImageForSource(entity) {
  if (!entity.has('feedimage')) {
    return {};
  }

  const compose = entity.get('compose');
  const feedimage = entity.get('feedimage');

  const outFeedImage = {};

  if (feedimage.type) {
    outFeedImage.type = feedimage.type;
  }
  if (feedimage.dropShadow) {
    outFeedImage.dropShadow = toJS(feedimage.dropShadow);
  }
  if (feedimage.opacity !== undefined) {
    outFeedImage.opacity = feedimage.opacity;
  }

  const canEdit = lodash.get(compose, 'canEdit', false);
  const variableName = lodash.get(compose, 'variableName');
  if (!canEdit || !variableName) {
    outFeedImage.url = feedimage.url;
  }

  return {
    feedimage: outFeedImage,
  };
}

